let apiHost = "";
let h5appid = "";
let socketUrl=''
if (process.env.env_config == "dev") {
  // 本地开发环境
  // apiHost = 'https://zuul.qcss.xyz'
  apiHost = 'https://vrhall.ccnfgame.com';
  // apiHost = "http://192.168.0.22:10004";
  // apiHost = "http://192.168.171.4:10004"
  //  apiHost = "http://192.168.0.29:8084";
  // apiHost = 'https://uat.ccnfgame.com/gateway'
  // apiHost = 'https://175.178.64.246:8095'/
  	// socketUrl='wss:/vrhall.ccnfgame.com/zhanhui/socket/'
	socketUrl='wss:/uat.ccnfgame.com/gateway/zhanhui/socket/'
} else if (process.env.env_config == "cdn") {
  // 正式环境
  // apiHost = 'http://121.32.135.141:8001'
  apiHost = "https://vrhall.ccnfgame.com";
  // apiHost = 'https://uat.ccnfgame.com/gateway'
  // socketUrl='wss:/uat.ccnfgame.com/zhanhui/socket/'
  socketUrl='wss:/vrhall.ccnfgame.com/zhanhui/socket/'
} else if (process.env.env_config == "prod") {
  // apiHost = "https://zuul.qcss.xyz";
  apiHost = "https://vrhall.ccnfgame.com";
  // apiHost="http://p35mu7.natappfree.cc"
  // apiHost = 'https://uat.ccnfgame.com/gateway'
  socketUrl='wss:/uat.ccnfgame.com/gateway/zhanhui/socket/'
}

export { apiHost, h5appid,socketUrl };

export const cdnConfig = {
  Bucket: "apps-1255573444",
  Region: "ap-guangzhou"
};



// WEBPACK FOOTER //
// ./src/config/miniConfig.js